import type { SettingsRevision, SettingsSaveRequest, SettingsTestResult, SettingsView } from '../api/contracts';

export interface SettingsDraft {
  values: Record<string, any>;
  secret_edits: Array<{field:string;item_id?:string;operation:'replace'|'clear';value?:string}>;
  mutation_key: string;
}
function cloneValues<T>(value:T):T { return JSON.parse(JSON.stringify(value)); }
export function createSettingsDraft(view: SettingsView): SettingsDraft {
  return {values: cloneValues(view.values),secret_edits:[],mutation_key:crypto.randomUUID()};
}
export function buildSaveRequest(view: SettingsView,draft: SettingsDraft): SettingsSaveRequest {
  return {expected_version:view.record_version,values:cloneValues(draft.values),secret_edits:draft.secret_edits.map(edit=>({...edit})),...(view.baseline_token?{baseline_token:view.baseline_token}:{})};
}
export function isSettingsDirty(view: SettingsView,draft: SettingsDraft) {
  return JSON.stringify(view.values)!==JSON.stringify(draft.values)||draft.secret_edits.length>0;
}
export function isCurrentTest(result: SettingsTestResult|null,revision: SettingsRevision|null,target:string) {
  return !!result&&JSON.stringify(result.revision)===JSON.stringify(revision)&&(result.target||'')===target;
}
export function disposeSettingsDraft(draft: SettingsDraft|null) {
  if(!draft)return;
  for(const edit of draft.secret_edits)if(edit.operation==='replace')edit.value='';
  draft.secret_edits.length=0;
  draft.values={};
}
export function canManagePlatformSettings(subject:any) {
  return !!subject?.roles?.includes('platform_admin')&&(subject?.permissions?.includes('*')||subject?.permissions?.includes('policy:write'))&&subject?.business_line_ids?.includes('*')&&subject?.org_scope?.includes('*');
}
